import { get } from 'stores/TransportState'

export const getReimbursementReminders = () =>
  get(`/api/reimbursement-reminders`)
    .then(x => x.json())

export const getSingleReimbursementReminder = (id) =>
  get(`/api/reimbursement-reminders/${id}`)
    .then(res => res.status === 204 ? null : res.json())
